import React, { PureComponent } from 'react'
import { ResponsiveContainer } from '../styledComponents'
import {
  SectionContainer,
  SectionWrapper,
  DesktopText,
  MobileText
} from './styledComponents'

export default class FooterMessageSection extends PureComponent {
  render() {
    const { footerMessageSection, id } = this.props
    const { desktopContent, mobileContent } = footerMessageSection
    return (
      <SectionContainer id={id}>
        <ResponsiveContainer>
          <SectionWrapper>
            <DesktopText
              as="p"
              dangerouslySetInnerHTML={{ __html: desktopContent }}
            />
            <MobileText
              as="p"
              dangerouslySetInnerHTML={{ __html: mobileContent }}
            />
          </SectionWrapper>
        </ResponsiveContainer>
      </SectionContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/FooterMessageSection/index.js